// Venue reject/failure reasons arrive in whatever shape the venue speaks: a sentence
// ("Insufficient margin balance [code 110044]"), a bare code (`EC_PostOnlyWillTakeLiquidity`,
// `not_enough_funds`, `ORDER_WOULD_TRIGGER_IMMEDIATELY`) or a sentence with a snake_case
// token in it. This turns each into plain words and drops the numeric error code, leaving
// real sentences untouched otherwise.
const CODE_SUFFIX = /\s*[[(]?\s*(?:error\s*)?(?:code|err(?:or)?)\s*[:=#]?\s*-?\d+\s*[\])]?\s*$/i
const CODE_PREFIX = /^(?:EC|ERR|ERROR|E)_(?=[A-Za-z])/

function wordsOf(token: string): string {
  return token
    .replace(CODE_PREFIX, '')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/[_.]+/g, ' ')
    .toLowerCase()
}

export function humanizeReason(raw: string | undefined | null): string {
  let text = (raw ?? '').trim().replace(CODE_SUFFIX, '').trim()
  if (!text) return ''
  if (!/\s/.test(text)) {
    // A single token: only rewrite it when it's shaped like a code.
    if (/[_]/.test(text) || /[a-z][A-Z]/.test(text) || /^[A-Z0-9]+$/.test(text)) {
      text = wordsOf(text)
    }
  } else {
    // In a sentence, only lowercase snake_case tokens are unambiguous codes — an
    // upper-case one like BTC_USDC is more likely a symbol.
    text = text.replace(/\b[a-z]+(?:_[a-z0-9]+)+\b/g, (token) => token.replace(/_/g, ' '))
  }
  text = text.replace(/\s+/g, ' ').trim()
  return text.charAt(0).toUpperCase() + text.slice(1)
}
